import { render, staticRenderFns } from "./YBLineItemView.vue?vue&type=template&id=15f4d606&scoped=true&"
import script from "./YBLineItemView.vue?vue&type=script&lang=js&"
export * from "./YBLineItemView.vue?vue&type=script&lang=js&"
import style0 from "./YBLineItemView.vue?vue&type=style&index=0&id=15f4d606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4d606",
  null
  
)

export default component.exports